// @flow

import React from 'react';

import {gt} from 'app/utils/i18n';

import {useAsyncActions} from 'app/utils/redux';
import {createProcess} from '../actions';
import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';

export const ProcessCreatePage = () => {
  const actions = useAsyncActions({createProcess});
  return (
    <GenericNewElementPage
      elementName={'proceduregroup'}
      createNewDocument={(processData) => actions.createProcess(processData)}
      advancedContent={
        <div className="mb-2">
          {gt(
            'Processes are collections of procedures. You can order the procedures, or even assign the whole process as a task.'
          )}
        </div>
      }
    />
  );
};
